import { createFileRoute } from '@tanstack/react-router';

import { CallPolicySettings } from '#modules/user/features/profile/components/Settings/CallPolicy';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/calls'
)({
  component: CallPolicySettings,
  ssr: false,
});
